import { Component, OnInit, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { BaseComponent } from 'src/app/models/base-component';
import { CampeonatosService } from '../../services/campeonatos/campeonatos.service';
import { GlobalVariable } from 'src/app/global';
import { Util } from 'src/app/utils/utils';
import { PopupConfirmacionComponent } from 'src/app/base/components/popup-confirmacion/popup-confirmacion.component';
import { Observable, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { ClientesService } from 'src/app/snapquick/services/clientes/clientes.service';
import { RegistroClienteComponent } from 'src/app/base/components/registro-cliente/registro-cliente.component';
import { RolesPartidosService } from '../../services/roles-partidos/roles-partidos.service';
import { RolPartidoPdfService } from '../../services/rol-partido-pdf/rol-partido-pdf.service';
import { Socket } from 'ngx-socket-io';
import { RegistroJugadorComponent } from '../registro-jugador/registro-jugador.component';
import * as CryptoJS from 'crypto-js';
import { TarjetasJugadorComponent } from '../tarjetas-jugador/tarjetas-jugador.component';
import { CertificadosCampeonatoComponent } from '../certificados-campeonato/certificados-campeonato.component';
import { JugadoresDuplicadosComponent } from '../jugadores-duplicados/jugadores-duplicados.component';
import { ProductosService } from 'src/app/snapquick/services/productos/productos.service';
import { ClientesHistoricoVentasComponent } from 'src/app/snapquick/components/clientes-historico-ventas/clientes-historico-ventas.component';
import { VentaComponent } from 'src/app/base/components/venta/venta.component';
import { PagoVentaComponent } from 'src/app/snapquick/components/pago-venta/pago-venta.component';
import { VentasService } from 'src/app/base/services/ventas/ventas.service';
import { FichaDeudaJugadorComponent } from '../ficha-deuda-jugador/ficha-deuda-jugador.component';

declare const PDFDocument:any;
declare const blobStream:any;
declare const qr:any
declare const $:any;
declare const resaltarPestañaMenu:any;
declare const aplicarSubidaArchivo:any;
declare const aplicarVisorImagenes:any;

@Component({
    selector: 'app-campeonatos',
    templateUrl: './campeonatos.component.html',
    styleUrls: ['./campeonatos.component.css'],
    standalone: false
})
export class CampeonatosComponent extends BaseComponent implements OnInit {

  categoria_tab:any={};
  campeonatos:any[]=[];
  equipos:any[]=[];
  jugadores:any[]=[];
  campeonato:any;
  cuentas_clientes:any[]=[];
  paginator_saldos_clientes:any=null;
  //colores de las tarjetas de pendientes economicos, segun cuanto debe el equipo respecto al que mas debe
  niveles_deuda:any[]=[
    { nombre:"Deuda alta", porcentaje_minimo:66, color:"#d9363e", color_texto:"#ffffff" },
    { nombre:"Deuda media", porcentaje_minimo:33, color:"#f28c28", color_texto:"#ffffff" },
    { nombre:"Deuda baja", porcentaje_minimo:0, color:"#f5c518", color_texto:"#3a3a3a" }
  ];
  equipo:any;
  tipo_categoria:any;
  tipo_nivel:any;
  tipo_disciplina:any
  searching = false;
  searchFailed = false;
  cliente_registrado:boolean=false;
  razon_busqueda:any;
  modalCliente:NgbModalRef;
  modalJugador:NgbModalRef;
  tabla_equipo_general:any={habilitar_jugadores:false};
  producto_busqueda:any;
  producto_inscripcion_busqueda:any;
  //arbitraje por disciplina: disciplina elegida para el proximo producto y texto de busqueda del producto
  arbitraje_nuevo:any={disciplina:null};
  //regla de juego que se esta armando en el formulario del campeonato
  regla_nueva:any={};
  arbitraje_busqueda:any;

  @ViewChildren('campeonatos') campeonatos_lectura: QueryList<any>;
  modalHistoricoVentas:NgbModalRef;
  modalVenta:NgbModalRef;

  modal_campeonato_modificacion:NgbModalRef;
  @ViewChild('modal_campeonato_modificacion')
  private modal_campeonato_modificacion_ref: TemplateRef<any>;

  modal_lista_equipos:NgbModalRef;
  @ViewChild('modal_lista_equipos')
  private modal_lista_equipos_ref: TemplateRef<any>;

  modal_equipo_modificacion:NgbModalRef;
  @ViewChild('modal_equipo_modificacion')
  private modal_equipo_modificacion_ref: TemplateRef<any>;

  modal_lista_jugadores:NgbModalRef;
  @ViewChild('modal_lista_jugadores')
  private modal_lista_jugadores_ref: TemplateRef<any>;

  modal_jugador_modificacion:NgbModalRef;
  @ViewChild('modal_jugador_modificacion')
  private modal_jugador_modificacion_ref: TemplateRef<any>;

  modal_configuracion_tarjeta_jugador:NgbModalRef;
  @ViewChild('modal_configuracion_tarjeta_jugador')
  private modal_configuracion_tarjeta_jugador_ref: TemplateRef<any>;

  modal_configuracion_pdf_rol_partido:NgbModalRef;
  //copia que edita el modal de configuracion del PDF del rol, y el estado de su vista previa
  configuracion_pdf_rol:any={};
  vista_previa_rol:any=null;
  vista_previa_pendiente:boolean=false;
  temporizador_vista_previa:any;
  numero_fondo_vista_previa:number=1;
  /* Las versiones son solo para las imagenes de redes, que llevan de 2 a 8 partidos: el rol de
     ejemplo trae 8 y la vista previa dibuja los primeros que se elijan (4 por defecto, la previa
     tipica de 24 horas antes). */
  partidos_ejemplo:number=8;
  cantidades_vista_previa:number[]=[2,3,4,5,6,7,8];
  versiones_rol_partido:any[]=[
    { version:1, nombre:"1 · Tarjetas en cuadrícula" },
    { version:2, nombre:"2 · Fixture en lista" },
    { version:3, nombre:"3 · Tarjetas con logos grandes" }
  ];
  @ViewChild('modal_configuracion_pdf_rol_partido')
  private modal_configuracion_pdf_rol_partido_ref: TemplateRef<any>;

  modal_saldo_equipos:NgbModalRef;
  @ViewChild('modal_saldo_equipos')
  private modal_saldo_equipos_ref: TemplateRef<any>;

  //division de una deuda colectiva del club (inscripcion, arbitraje) entre los jugadores del equipo
  division_venta:any=null;
  modal_division_venta:NgbModalRef;
  @ViewChild('modal_division_venta')
  private modal_division_venta_ref: TemplateRef<any>;

  modal_impresion_tarjetas_jugador:NgbModalRef;

  //enlace de la venta de inscripcion con el equipo
  equipo_inscripcion:any=null;
  ventas_inscripcion:any[]=[];
  modal_inscripcion_equipo:NgbModalRef;
  @ViewChild('modal_inscripcion_equipo')
  private modal_inscripcion_equipo_ref: TemplateRef<any>;

  escenarios:any[]=[];
  /* Dias en la numeracion de Date.getDay(): 0 domingo ... 6 sabado, para cruzarlos directamente
     con las fechas al planificar la semana. */
  dias_semana:any[]=[{dia:1,nombre:"Lunes"},{dia:2,nombre:"Martes"},{dia:3,nombre:"Miércoles"},
                     {dia:4,nombre:"Jueves"},{dia:5,nombre:"Viernes"},{dia:6,nombre:"Sábado"},
                     {dia:0,nombre:"Domingo"}];

  constructor(private router: Router,
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    private toastr: ToastrService,
    public campeonatosService:CampeonatosService,
    public clientesService:ClientesService,
    public rolesPartidosService:RolesPartidosService,
    public rolPartidoPdfService:RolPartidoPdfService,
    private socket: Socket,
    public productosService:ProductosService,
    public ventasService:VentasService) {
      super(persistenciaService,modalService,generalService,usuarioService);
    }

  ngOnInit(): void {
    this.init();
		this.buscarAplicacion(this.router.url.substring(1));
		this.configuracion_pagina={};
		this.filter={
			id_empresa:this.usuario.id_empresa
		}
		//this.obtenerConfiguracionPagina(GlobalVariable.Dictionary.CODIGO_APP_RUTAS);

    this.column = "fecha_inicio";
		this.getSearch(this.text_search,null);
  }

  ngAfterViewInit() {
		resaltarPestañaMenu(this.router.url.substring(1)+"1");
    this.campeonatos_lectura.changes.subscribe(t => {
      aplicarVisorImagenes("imagen-campeonato-vista");
    });
  }

  getItems(){
		this.blockUI.start('Recuperando... espere por favor!');
		this.campeonatosService.obtenerListaCampeonatos(this).subscribe((dato:any) => {
			this.setPages(dato.paginas);
			this.campeonatos=dato.campeonatos;
			this.blockUI.stop();
		});
	}

  abrirConfiguracionAplicacion(){
		
	}

  async crearNuevoCampeonato(){
    this.arbitraje_nuevo={disciplina:null};
    this.arbitraje_busqueda="";
    this.obtenerDisciplinasEquiposEmpresa();
    this.obtenerCategoriasEquiposEmpresa();
    this.iniciarReglaNueva();
    this.producto_busqueda="";
    this.producto_inscripcion_busqueda="";
    let codigo_nuevo=await this.obtenerUltimoCodigo(GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_CAMPEONATO);
    this.campeonato={      
        id_empresa: this.usuario.id_empresa, id_usuario:this.usuario.id,
        codigo:codigo_nuevo,
        activo:true,
        arbitrajes:[],
        reglas:[],
        configuracion_tarjeta_jugador:{
          fondo_color_tarjeta:"#06427e",
          titulo_color_liga:"#ffffff",
          titulo_color_jugador:"#ffff00",
          enunciados_color:"#ffffff",
          datos_color:"#ffff00"
        }
    }
    this.abrirRegistroCampeonato();
  }

  abrirRegistroCampeonato(){
    this.modal_campeonato_modificacion=this.modalService.open(this.modal_campeonato_modificacion_ref, {
      windowClass: 'registro-campeonato',
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      container: 'body'
    });
    this.modal_campeonato_modificacion.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    aplicarSubidaArchivo('dropzone','preview-template',this,'subirArchivo','eliminarArchivo',{maximo_tamano_archivo:10});
    aplicarSubidaArchivo('fondo-tabla','fondo-tabla-template',this,'subirArchivoFondo','eliminarArchivoFondo',{maximo_tamano_archivo:10});
    aplicarSubidaArchivo('fondo-rol','fondo-rol-template',this,'subirArchivoRol','eliminarArchivoRol',{maximo_tamano_archivo:10});
  }

  subirArchivo(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.campeonato.logo=base64EncodedImage;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  eliminarArchivo(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.campeonato.logo=null;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  subirArchivoFondo(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.campeonato.fondo_tabla_posiciones=base64EncodedImage;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  eliminarArchivoFondo(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.campeonato.fondo_tabla_posiciones=null;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  subirArchivoRol(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.campeonato.fondo_rol_partido=base64EncodedImage;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  eliminarArchivoRol(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.campeonato.fondo_rol_partido=null;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  validarFormularioRegistroCampeonato(){
		let res=true;
		if(!this.campeonato.nombre){
			this.toastr.error("Debe especificar el nombre del campeonato!");
			res=false;
		}
		if(!this.campeonato.fecha_inicio_texto || !this.campeonato.fecha_inicio_texto.year || !this.campeonato.fecha_inicio_texto.month || !this.campeonato.fecha_inicio_texto.day){
      res=res && false;
      this.toastr.error("Debe especificar la fecha de inicio completa para el campeonato!");
    }
		return res;
	}

	guardarCampeonato(){
		if(this.validarFormularioRegistroCampeonato()){
			this.blockUI.start();
      this.campeonato.fecha_inicio=Util.convertirObjetoAfecha(this.campeonato.fecha_inicio_texto);
      this.campeonato.fecha_fin=this.campeonato.fecha_fin_texto?Util.convertirObjetoAfecha(this.campeonato.fecha_fin_texto):null;
			if(this.campeonato.id){
				this.campeonatosService.actualizarCampeonato(this.campeonato).subscribe((res:any) => {
					this.blockUI.stop();
					this.toastr.success("Campeonato registrado satisfactoriamente");
          this.getItems();
					this.modal_campeonato_modificacion.close();
				});
			}else{
				this.campeonatosService.guardarCampeonato(this.campeonato).subscribe((res:any) => {
          this.actualizarUltimoCodigo(GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_CAMPEONATO);
					this.blockUI.stop();
					this.toastr.success(res.mensaje);
          this.getItems();
					this.modal_campeonato_modificacion.close();
				});
			}
		}
		
	}

  async modificarCampeonato(campeonato){
    this.producto_busqueda="";
    this.producto_inscripcion_busqueda="";
    this.campeonato=campeonato;
    this.campeonato.arbitrajes=this.campeonato.arbitrajes?this.campeonato.arbitrajes:[];
    this.campeonato.reglas=this.campeonato.reglas?this.campeonato.reglas:[];
    this.arbitraje_nuevo={disciplina:null};
    this.arbitraje_busqueda="";
    this.obtenerDisciplinasEquiposEmpresa();
    this.obtenerCategoriasEquiposEmpresa();
    this.iniciarReglaNueva();
    this.campeonato.fecha_inicio_texto=Util.convertirFechaAObjectoFecha(new Date(this.campeonato.fecha_inicio));
    this.campeonato.fecha_fin_texto=this.campeonato.fecha_fin?Util.convertirFechaAObjectoFecha(new Date(this.campeonato.fecha_fin)):null;
    this.abrirRegistroCampeonato();
  }

  async obtenerCategoriasEquiposEmpresa(){
		this.tipo_categoria=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_EQUIPO_CATEGORIAS).toPromise();
	}

  async obtenerNivelesEquiposEmpresa(){
		this.tipo_nivel=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_EQUIPO_NIVELES).toPromise();
	}

  async obtenerDisciplinasEquiposEmpresa(){
		this.tipo_disciplina=await this.generalService.obtenerClasesEmpresa(this.usuario.id_empresa,GlobalVariable.Dictionary.TIPO_EQUIPO_DISCIPLINAS).toPromise();
	}

  async verEquipos(campeonato){
    this.campeonato=campeonato;    
    this.obtenerEquiposCampeonato();
    this.obtenerCategoriasEquiposEmpresa();
    this.obtenerNivelesEquiposEmpresa();
    this.obtenerDisciplinasEquiposEmpresa();
    this.modal_lista_equipos=this.modalService.open(this.modal_lista_equipos_ref, {scrollable:true,windowClass:'lista-equipos',ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
    this.modal_lista_equipos.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  async crearNuevoEquipo(campeonato){
    this.razon_busqueda=null;
    this.cliente_registrado=false;
    let codigo_nuevo=await this.obtenerUltimoCodigo(GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_EQUIPO);
    this.equipo={
        id_empresa:this.usuario.id_empresa,
        id_campeonato: campeonato.id,
        codigo:codigo_nuevo,
        activo:true,
        cantidad_jugadores:0,
        cliente:{},
        restricciones:[],
        //si el campeonato tiene inscripcion configurada, al guardar se pasa directo al cobro
        cobrar_inscripcion:!!(campeonato.producto_inscripcion && campeonato.producto_inscripcion.id)
    }
    this.obtenerEscenariosRestricciones();
    this.abrirRegistroEquipo();
  }

  abrirRegistroEquipo(){
    this.modal_equipo_modificacion=this.modalService.open(this.modal_equipo_modificacion_ref, {scrollable:true,ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
    this.modal_equipo_modificacion.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    aplicarSubidaArchivo('logo-equipo','preview-template-logo',this,'subirArchivoLogo','eliminarArchivoLogo',{maximo_tamano_archivo:10});
  }

  validarFormularioRegistroEquipo(){
		let res=true;
		if(!this.equipo.nombre){
			this.toastr.error("Debe especificar el nombre del equipo!");
			res=false;
		}
    if(!this.equipo.nivel){
			this.toastr.error("Debe especificar el nivel del equipo!");
			res=false;
		}
    if(!this.equipo.categoria){
			this.toastr.error("Debe especificar la categoria del equipo!");
			res=false;
		}
    if(!this.equipo.disciplina){
			this.toastr.error("Debe especificar la disciplina del equipo!");
			res=false;
		}
    if(!this.equipo.cliente.razon_social){
			this.toastr.error("Debe especificar el nombre del delegado!");
			res=false;
		}
    if(!this.equipo.cliente.telefono1){
			this.toastr.error("Debe especificar el telefono del delegado!");
			res=false;
		}
		return res;
	}

	guardarEquipo(){
		if(this.validarFormularioRegistroEquipo()){
			this.blockUI.start();
			if(this.equipo.id){
				this.campeonatosService.actualizarEquipo(this.equipo).subscribe((res:any) => {
					this.blockUI.stop();
					this.toastr.success(res.mensaje);
          this.obtenerEquiposCampeonato();
					this.modal_equipo_modificacion.close();
				});
			}else{
				this.campeonatosService.guardarEquipo(this.equipo).subscribe((res:any) => {
          this.actualizarUltimoCodigo(GlobalVariable.Dictionary.TIPO_CORRELATIVO_CODIGO_EQUIPO);
					this.blockUI.stop();
					this.toastr.success(res.mensaje);
          this.obtenerEquiposCampeonato();
					this.modal_equipo_modificacion.close();
          /* Se encadena el cobro: el cliente lo devuelve el servidor, ya sea el que se buscó o el
             que se creó con los datos del delegado, asi no hay que ir a Ventas a registrarlo. */
          if(this.equipo.cobrar_inscripcion && res.cliente){
            this.cobrarInscripcion({ id:res.equipo.id, cliente:res.cliente, categoria:this.equipo.categoria });
          }
				});
			}
		}
		
	}

  obtenerEquiposCampeonato(){
    this.blockUI.start('Recuperando... espere por favor!');
		this.campeonatosService.obtenerListaEquipos(this.campeonato.id,0,0).subscribe((equipos:any) => {
      this.equipos=this.agruparPorCategoria(equipos);
      //sin equipos no hay pestañas: se deja un objeto vacio para que la plantilla no reviente
      this.establecerCategoriaTab(this.equipos.length>0?this.equipos[0]:{});
			this.blockUI.stop();
		});
  }

  agruparPorCategoria = (lista) => {
    // 1. Agrupamos en un objeto intermedio usando la categoría como llave
    const grupos = lista.reduce((acc, equipo) => {
      const key = equipo.id_categoria+"-"+equipo.id_disciplina;

    if (!acc[key]) {
      // Creamos la estructura con la descripción y el array vacío
      acc[key] = {
            nombre: equipo.categoria.nombre, // Aquí agregas la descripción
            disciplina:equipo.disciplina.nombre,
            //las disciplinas guardan su color en nombre_corto, igual que en el rol de partidos
            color_disciplina:this.colorTextoClase(equipo.disciplina),
            id: key,
            listaEquipos: []
          };
        }

        // Agregamos el equipo a la lista interna de ese objeto
        acc[key].listaEquipos.push(equipo);

        return acc;
      }, {})

    // 2. Convertimos los valores del objeto en un array de arrays
    //se recorren las claves en vez de Object.values() para que el tipo salga inferido
    let lista_grupos=[];
    Object.keys(grupos).forEach(clave => lista_grupos.push(grupos[clave]));
    //se ordenan acá y no en la plantilla, para poder dejar TODOS siempre primero
    lista_grupos.sort((uno,otro) => String(uno.nombre).localeCompare(String(otro.nombre)));
    /* Pestaña con todos los equipos del campeonato, para verlos juntos sin ir categoria por
       categoria. Con un solo grupo no se agrega: seria la misma lista repetida. */
    if(lista_grupos.length>1){
      lista_grupos.unshift({ nombre:"TODOS", disciplina:"", color_disciplina:null,
                             id:"TODOS", listaEquipos:lista.slice() });
    }
    return lista_grupos;
  }

  establecerCategoriaTab(categoria){
    this.categoria_tab=categoria;
  }

  /* Las disciplinas y categorias guardan su color en nombre_corto, igual que en el rol de
     partidos. Si ahi no hay un color, se devuelve null y el texto queda con el color normal. */
  colorClase(clase){
    return (clase && clase.nombre_corto && String(clase.nombre_corto).charAt(0)=="#")?clase.nombre_corto:null;
  }

  /* Esos colores se eligieron para el fondo del PDF y como texto sobre blanco quedan flojos (entre
     2.8 y 3.8 de contraste). Para la pestaña se oscurecen manteniendo el tono hasta llegar a 4.5:1,
     que es el minimo para que se lean. */
  colorTextoClase(clase){
    let color=this.colorClase(clase);
    if(!color){
      return null;
    }
    let canales=[1,3,5].map(i => parseInt(color.substr(i,2),16));
    let factor=1;
    while(factor>0.2 && this.contrasteSobreBlanco(canales.map(canal => Math.round(canal*factor)))<4.5){
      factor=factor-0.05;
    }
    return "#"+canales.map(canal => {
      let valor=Math.max(0,Math.min(255,Math.round(canal*factor)));
      return (valor<16?"0":"")+valor.toString(16);
    }).join("");
  }

  contrasteSobreBlanco(canales){
    let lineales=canales.map(canal => canal/255)
                        .map(valor => (valor<=0.04045)?(valor/12.92):Math.pow((valor+0.055)/1.055,2.4));
    let luminancia=0.2126*lineales[0]+0.7152*lineales[1]+0.0722*lineales[2];
    return 1.05/(luminancia+0.05);
  }

  subirArchivoLogo(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.equipo.logo=base64EncodedImage;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  eliminarArchivoLogo(file){
    let me=this;
		var fileToLoad = file;
			var fileReader = new FileReader();

			fileReader.onloadend = function() 
			{
				let base64EncodedImage = fileReader.result; // <--- data: base64
        me.equipo.logo=null;
			}
			fileReader.readAsDataURL(fileToLoad);	
  }

  async modificarEquipo(equipo){
    this.equipo=equipo;
    this.equipo.cliente=equipo.cliente?equipo.cliente:{};
    this.equipo.id_empresa=this.usuario.id_empresa;
    this.equipo.restricciones=this.equipo.restricciones?this.equipo.restricciones:[];
    this.obtenerEscenariosRestricciones();
    this.abrirRegistroEquipo();
  }

  /* Los escenarios hacen falta para las restricciones del equipo, que dicen en cual si o en cual
     no se le puede programar. */
  obtenerEscenariosRestricciones(){
    if(this.escenarios.length>0){
      return;
    }
    this.rolesPartidosService.obtenerEscenarios(this.usuario.id_empresa).subscribe((escenarios:any) => {
      this.escenarios=escenarios;
    });
  }

  agregarRestriccionEquipo(){
    this.equipo.restricciones=this.equipo.restricciones?this.equipo.restricciones:[];
    this.equipo.restricciones.push({ tipo:"DIA_NO", dia:2, id_escenario:null, hora:18, minuto:0 });
  }

  quitarRestriccionEquipo(indice){
    this.equipo.restricciones.splice(indice,1);
  }

  async verJugadores(equipo){
    this.equipo=equipo;
    this.obtenerJugadoresEquipo();
    this.modal_lista_jugadores=this.modalService.open(this.modal_lista_jugadores_ref, {ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
    this.modal_lista_jugadores.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  async crearNuevoJugador(equipo){
    this.modalJugador = this.modalService.open(RegistroJugadorComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    this.modalJugador.componentInstance.equipo = equipo;
		this.modalJugador.componentInstance.usuario = this.usuario;
		
		this.modalJugador.componentInstance.alTerminar.subscribe((res) => {
			if(res){
				if(res.tiene_error){
					this.toastr.error(res.mensaje);
					this.toastr.error(res.stack.substring(0,500));
				}else{
					this.obtenerJugadoresEquipo();
					this.modalJugador.close();
				}
			}else{
				this.modalJugador.close();
			}
			
		});
  }

  obtenerJugadoresEquipo(){
    this.blockUI.start('Recuperando... espere por favor!');
		this.campeonatosService.obtenerListaJugadores(this.usuario.id_empresa,this.equipo.id).subscribe((jugadores:any) => {
			this.jugadores=jugadores;
			this.blockUI.stop();
		});
  }

  async modificarJugador(jugador_a_modificar){
    let jugador:any=jugador_a_modificar;
    jugador.persona.fecha_nacimiento_texto=jugador.persona.fecha_nacimiento?Util.convertirFechaAObjectoFecha(new Date(jugador.persona.fecha_nacimiento)):null;
    jugador.id_empresa=this.usuario.id_empresa;

    this.modalJugador = this.modalService.open(RegistroJugadorComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    this.modalJugador.componentInstance.equipo = this.equipo;
    this.modalJugador.componentInstance.jugador = jugador;
		this.modalJugador.componentInstance.usuario = this.usuario;
		
		this.modalJugador.componentInstance.alTerminar.subscribe((res) => {
			if(res){
				if(res.tiene_error){
					this.toastr.error(res.mensaje);
					this.toastr.error(res.stack.substring(0,500));
				}else{
					this.obtenerJugadoresEquipo();
					this.modalJugador.close();
				}
			}else{
				this.modalJugador.close();
			}
		});
  }

  abrirJugadoresDuplicados(){
    let modal_duplicados = this.modalService.open(JugadoresDuplicadosComponent, {scrollable:true,size:'xl',ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    modal_duplicados.componentInstance.usuario = this.usuario;
    modal_duplicados.componentInstance.alTerminar.subscribe((res) => {
      modal_duplicados.close();
    });
  }

  abrirModalGeneracionPdfTarjetasJugador(){
    this.modal_impresion_tarjetas_jugador = this.modalService.open(TarjetasJugadorComponent, {windowClass:'tarjetas-jugador',scrollable:true,ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
		this.modal_impresion_tarjetas_jugador.componentInstance.usuario = this.usuario;
		
		this.modal_impresion_tarjetas_jugador.componentInstance.alTerminar.subscribe((res) => {
			this.modal_impresion_tarjetas_jugador.close();
		});
  }

  abrirModalCertificados(campeonato){
    let modal_certificados=this.modalService.open(CertificadosCampeonatoComponent, {windowClass:'certificados-campeonato',fullscreen:true,scrollable:true,ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    modal_certificados.componentInstance.campeonato = campeonato;
    modal_certificados.componentInstance.usuario = this.usuario;
    modal_certificados.componentInstance.alTerminar.subscribe((res) => {
      modal_certificados.close();
    });
  }

  abrirModalConfiguracionTarjetaJugador(campeonato){
    this.campeonato=campeonato;
    this.campeonato.configuracion_tarjeta_jugador=this.campeonato.configuracion_tarjeta_jugador?this.campeonato.configuracion_tarjeta_jugador:{
      fondo_color_tarjeta:"#06427e",
      titulo_color_liga:"#ffffff",
      titulo_color_jugador:"#ffff00",
      enunciados_color:"#ffffff",
      datos_color:"#ffff00"
    }
    this.modal_configuracion_tarjeta_jugador=this.modalService.open(this.modal_configuracion_tarjeta_jugador_ref, {ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
    this.modal_configuracion_tarjeta_jugador.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  guardarConfiguracionTarjetaJugador(){
    this.blockUI.start();
    this.campeonatosService.actualizarComfiguracionTarjetaJugadorCampeonato(this.campeonato).subscribe((res:any) => {
      this.blockUI.stop();
      this.toastr.success(res.mensaje);
      this.modal_configuracion_tarjeta_jugador.close();
    });
  }

  /* Configuracion del PDF del rol con vista previa en vivo. Se edita una copia (configuracion_pdf_rol),
     asi cerrar sin guardar no deja cambios a medias en el campeonato. La vista previa dibuja un rol
     real del campeonato con el mismo RolPartidoPdfService que despues imprime el rol. */
  abrirModalConfiguracionPdfRolPartido(campeonato){
    this.campeonato=campeonato;
    let copia={ configuracion_pdf_rol_partido:campeonato.configuracion_pdf_rol_partido?Object.assign({},campeonato.configuracion_pdf_rol_partido):null };
    this.configuracion_pdf_rol=this.rolPartidoPdfService.asegurarConfiguracionPdfRolPartido(copia);
    this.vista_previa_rol={ roles:[], rol_seleccionado:null, rol_datos:null, con_resultados:false, cantidad:4,
                            pdf:null, url_blob:null, generando:false, cargando_rol:false, mensaje:null, total_partidos:0 };
    //una cancha de fondo fija mientras el modal esta abierto, si no cambiaria en cada regeneracion
    this.numero_fondo_vista_previa=Math.floor(Math.random()*6)+1;
    this.rolPartidoPdfService.limpiarCacheImagenes();
    this.modal_configuracion_pdf_rol_partido=this.modalService.open(this.modal_configuracion_pdf_rol_partido_ref, {windowClass:'configuracion-pdf-rol',ariaLabelledBy: 'modal-basic-title',size: 'xl', backdrop: 'static', scrollable:true});
    this.modal_configuracion_pdf_rol_partido.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      this.cerrarVistaPreviaRol();
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      this.cerrarVistaPreviaRol();
    });
    this.cargarRolesVistaPrevia();
  }

  guardarConfiguracionPdfRolPartido(){
    this.blockUI.start();
    this.campeonato.configuracion_pdf_rol_partido=Object.assign({},this.configuracion_pdf_rol);
    this.campeonatosService.actualizarComfiguracionTarjetaJugadorCampeonato(this.campeonato).subscribe((res:any) => {
      this.blockUI.stop();
      this.toastr.success(res.mensaje);
      this.modal_configuracion_pdf_rol_partido.close();
    });
  }

  /* La vista previa no depende de que el campeonato ya tenga roles: por defecto dibuja un rol de
     ejemplo armado con sus equipos (o con equipos ficticios si todavia no tiene). Si ya hay roles,
     se ofrecen tambien en el selector, el mas reciente primero. */
  async cargarRolesVistaPrevia(){
    let vista=this.vista_previa_rol;
    let paginador={ filter:{ id_empresa:this.usuario.id_empresa, campeonato:this.campeonato, usuario:{} },
                    currentPage:1, itemsPerPage:30, search:0, column:"id", direction:"desc" };
    vista.cargando_rol=true;
    //cada consulta por su lado: si una falla, el ejemplo se arma igual con lo que haya
    let [roles,equipos,escenarios]:any[]=await Promise.all([
      this.rolesPartidosService.obtenerListaRolesPartidos(paginador).toPromise().then((res:any) => res.roles_partidos?res.roles_partidos:[]).catch(() => []),
      this.campeonatosService.obtenerListaEquipos(this.campeonato.id,0,0).toPromise().catch(() => []),
      this.rolesPartidosService.obtenerEscenarios(this.usuario.id_empresa).toPromise().catch(() => [])
    ]);
    if(this.vista_previa_rol!==vista){
      return; //el modal se cerro mientras se cargaba
    }
    vista.cargando_rol=false;
    vista.rol_ejemplo=this.armarRolEjemplo(equipos,escenarios);
    let ejemplo={ es_ejemplo:true, rol:{ nombre:vista.rol_ejemplo.con_equipos_reales?"Ejemplo con los equipos del campeonato":"Ejemplo con equipos ficticios" } };
    vista.roles=[ejemplo].concat(roles);
    vista.rol_seleccionado=ejemplo;
    await this.cambiarRolVistaPrevia();
  }

  async cambiarRolVistaPrevia(){
    let vista=this.vista_previa_rol;
    let rol=vista.rol_seleccionado;
    if(!rol){
      return;
    }
    vista.mensaje=null;
    if(rol.es_ejemplo){
      vista.rol_datos=vista.rol_ejemplo;
    }else{
      vista.cargando_rol=true;
      try{
        vista.rol_datos=await this.rolesPartidosService.obtenerRolPartido(rol.id).toPromise();
      }catch(error){
        vista.rol_datos=null;
        vista.mensaje="No se pudo traer el rol para la vista previa.";
      }
      vista.cargando_rol=false;
    }
    this.generarVistaPreviaRol();
  }

  /* Rol de ejemplo con la misma forma que devuelve el servidor. Los cruces salen de equipos de la
     misma categoria y disciplina, tomando una pareja de cada grupo por vuelta para que se vean varias
     categorias; los partidos son del proximo sabado, cada hora, alternando dos canchas, y traen
     marcador y tarjetas para la vista de resultados. */
  armarRolEjemplo(equipos,escenarios){
    let maximo=this.partidos_ejemplo;
    let logo_defecto="./img/icon-logo-equipo-default.png";
    let activos=(equipos?equipos:[]).filter(equipo => equipo.activo!==false && equipo.nombre);
    let grupos={};
    activos.forEach(equipo => {
      let llave=equipo.id_categoria+"-"+equipo.id_disciplina;
      grupos[llave]=grupos[llave]?grupos[llave]:[];
      grupos[llave].push(equipo);
    });
    let listas=Object.keys(grupos).map(llave => grupos[llave]);
    let parejas=[];
    for(let vuelta=0;parejas.length<maximo;vuelta++){
      let agregadas=0;
      listas.forEach(lista => {
        if(parejas.length<maximo && lista.length>=2*vuelta+2){
          parejas.push([lista[2*vuelta],lista[2*vuelta+1]]);
          agregadas++;
        }
      });
      if(agregadas==0){
        break;
      }
    }
    //ningun grupo tiene dos equipos: se cruzan igual, en orden, solo para ver el diseño
    if(parejas.length==0){
      for(let i=0;i+1<activos.length && parejas.length<maximo;i=i+2){
        parejas.push([activos[i],activos[i+1]]);
      }
    }
    let con_equipos_reales=parejas.length>0;
    if(!con_equipos_reales){
      //nombres de distinto largo, para ver tambien como se cortan los nombres largos
      let nombres=["LOS HALCONES","DEPORTIVO SAN JOSÉ","ACADEMIA REAL","LEONES FC","UNIÓN JUVENIL",
                   "ESTRELLA ROJA","ATLÉTICO CENTRAL","LOS PUMAS","CLUB DEPORTIVO LOS ANDES","TIGRES",
                   "REAL SANTA CRUZ","HURACANES","INDEPENDIENTE","SAN MARTÍN","BOLÍVAR JUNIOR","LOS CÓNDORES"];
      let categorias=(this.tipo_categoria && this.tipo_categoria.clases && this.tipo_categoria.clases.length>0)?this.tipo_categoria.clases:[{ nombre:"LIBRE" }];
      let disciplinas=(this.tipo_disciplina && this.tipo_disciplina.clases && this.tipo_disciplina.clases.length>0)?this.tipo_disciplina.clases:[{ nombre:"FÚTBOL DE SALÓN" }];
      for(let i=0;i<maximo;i++){
        let categoria=categorias[i%categorias.length],disciplina=disciplinas[i%disciplinas.length];
        parejas.push([{ nombre:nombres[2*i], logo:logo_defecto, categoria:categoria, disciplina:disciplina },
                      { nombre:nombres[2*i+1], logo:logo_defecto, categoria:categoria, disciplina:disciplina }]);
      }
    }

    escenarios=(escenarios && escenarios.length>0)?escenarios:[{ nombre:"CANCHA PRINCIPAL" }];
    //el proximo sabado desde las 14:00, un partido por hora
    let sabado=new Date();
    sabado.setDate(sabado.getDate()+((6-sabado.getDay()+7)%7 || 7));
    sabado.setHours(14,0,0,0);
    let copiaEquipo=(equipo) => ({ nombre:equipo.nombre, logo:equipo.logo?equipo.logo:logo_defecto });
    let partidos=parejas.map((pareja,i) => {
      let fecha=new Date(sabado.getTime());
      fecha.setHours(fecha.getHours()+i);
      return {
        activo:true,
        fecha_hora:fecha,
        equipo_1:copiaEquipo(pareja[0]),
        equipo_2:copiaEquipo(pareja[1]),
        categoria:pareja[0].categoria?pareja[0].categoria:{ nombre:"LIBRE" },
        disciplina:pareja[0].disciplina?pareja[0].disciplina:{ nombre:"FÚTBOL DE SALÓN" },
        escenario:escenarios[i%Math.min(2,escenarios.length)],
        marcador_equipo_1:(i*3+1)%5,
        marcador_equipo_2:(i*2)%4,
        lista_amarillas_equipo_1:new Array(i%3).fill({}),
        lista_rojas_equipo_1:(i%4==1)?[{}]:[],
        lista_amarillas_equipo_2:new Array((i+1)%3).fill({}),
        lista_rojas_equipo_2:(i%5==3)?[{}]:[],
        w_o_equipo_1:{ es_wo:false },
        w_o_equipo_2:{ es_wo:false }
      };
    });
    return {
      id:null,
      con_equipos_reales:con_equipos_reales,
      rol:{ nombre:"FECHA 1" },
      campeonato:JSON.parse(JSON.stringify(this.campeonato)),
      partidos:partidos
    };
  }

  //cada cambio espera un momento, asi escribir un numero no regenera el PDF en cada tecla
  programarVistaPreviaRol(){
    clearTimeout(this.temporizador_vista_previa);
    this.temporizador_vista_previa=setTimeout(() => this.generarVistaPreviaRol(),400);
  }

  async generarVistaPreviaRol(){
    let vista=this.vista_previa_rol;
    if(!vista || !vista.rol_datos){
      return;
    }
    //el servicio dibuja de a un documento por vez: si ya hay uno en curso, se vuelve a dibujar al terminar
    if(vista.generando){
      this.vista_previa_pendiente=true;
      return;
    }
    let colores=this.campeonato.configuracion_tarjeta_jugador?this.campeonato.configuracion_tarjeta_jugador:vista.rol_datos.campeonato.configuracion_tarjeta_jugador;
    if(!colores){
      vista.mensaje="El campeonato no tiene colores configurados. Configúralos en la tarjeta de jugador para poder generar el rol.";
      return;
    }
    if(vista.rol_datos.partidos.filter(p => p.activo).length==0){
      vista.total_partidos=0;
      vista.mensaje="El rol elegido no tiene partidos activos. Elige otro rol para ver la vista previa.";
      return;
    }
    vista.generando=true;
    vista.mensaje=null;
    try{
      let rol=JSON.parse(JSON.stringify(vista.rol_datos));
      //se dibuja con lo que se esta editando, no con lo guardado
      rol.campeonato=Object.assign({},rol.campeonato,{
        nombre:this.campeonato.nombre,
        logo:this.campeonato.logo,
        configuracion_tarjeta_jugador:JSON.parse(JSON.stringify(colores)),
        configuracion_pdf_rol_partido:Object.assign({},this.configuracion_pdf_rol)
      });
      rol=await this.rolPartidoPdfService.prepararRolPartido(rol);
      vista.total_partidos=rol.partidos.length;
      //una imagen para redes lleva de 2 a 8 partidos: se dibujan los primeros en el orden del dia
      rol.partidos=rol.partidos.sort((a,b) => new Date(a.fecha_hora).getTime()-new Date(b.fecha_hora).getTime())
                               .slice(0,vista.cantidad);
      let blob=await this.rolPartidoPdfService.generarBlobRolPartidos(rol,vista.con_resultados,
        { usuario:this.usuario, numero_fondo:this.numero_fondo_vista_previa, cache_imagenes:true });
      if(this.vista_previa_rol!==vista){
        return; //el modal se cerro mientras se dibujaba
      }
      if(vista.url_blob){
        URL.revokeObjectURL(vista.url_blob);
      }
      vista.url_blob=URL.createObjectURL(blob);
      vista.pdf=new Uint8Array(await blob.arrayBuffer());
    }catch(error){
      console.error(error);
      vista.mensaje="No se pudo dibujar la vista previa con este rol"+(vista.con_resultados?" y sus resultados":"")+".";
    }finally{
      vista.generando=false;
    }
    if(this.vista_previa_pendiente && this.vista_previa_rol===vista){
      this.vista_previa_pendiente=false;
      this.generarVistaPreviaRol();
    }
  }

  abrirVistaPreviaRolEnPestana(){
    if(this.vista_previa_rol && this.vista_previa_rol.url_blob){
      window.open(this.vista_previa_rol.url_blob,'_blank');
    }
  }

  cerrarVistaPreviaRol(){
    clearTimeout(this.temporizador_vista_previa);
    this.vista_previa_pendiente=false;
    if(this.vista_previa_rol && this.vista_previa_rol.url_blob){
      URL.revokeObjectURL(this.vista_previa_rol.url_blob);
    }
    this.vista_previa_rol=null;
    this.rolPartidoPdfService.limpiarCacheImagenes();
  }

  /* Baja/alta del equipo: no se borra el registro, solo se marca tor_equipo.activo. El equipo sigue
     apareciendo en la lista y en la matriz de cruces, resaltado, y se le pueden seguir programando
     partidos. */
  abrirPopupConfirmacionBajaEquipo(equipo){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = equipo.activo?
			("¿Esta seguro(a) de dar de baja al equipo "+equipo.nombre+"? Seguira visible y se le podran programar partidos, pero quedara marcado como retirado."):
			("¿Esta seguro(a) de habilitar nuevamente al equipo "+equipo.nombre+"?");
		this.popupConfirmacion.componentInstance.data = equipo;

		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
				this.actualizarAtributoEquipo($e.data,'activo',!$e.data.activo);
			}
			this.popupConfirmacion.close();
    });
	}

  abrirPopupConfirmacionEliminacionJugador(jugador){
		this.popupConfirmacion = this.modalService.open(PopupConfirmacionComponent);
		this.popupConfirmacion.componentInstance.message = "¿Esta seguro de eliminar al jugador?";
		this.popupConfirmacion.componentInstance.data = jugador;
		
		this.popupConfirmacion.componentInstance.onConfirm.subscribe(($e) => {
			if($e.confirm){
				this.eliminarJugador($e.data);
			}
			this.popupConfirmacion.close();
        });
	}
	  
	eliminarJugador(jugador){
		this.blockUI.start();
		this.campeonatosService.eliminarJugador(jugador).subscribe((dato:any)=>{
			this.blockUI.stop();
			if(dato.tiene_error){
				this.toastr.error(dato.mensaje);
			}else{
        this.obtenerJugadoresEquipo();
				this.toastr.success(dato.mensaje);
			}
		});
	}

  buscarCliente = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
	  switchMap( (term) =>  this.clientesService.buscarClienteNit(this.usuario.id_empresa,term,0)),
	  catchError(() => {
		this.searchFailed = true;
		return of([]);
	  })  ,
      tap(() => this.searching = false)
	)
	
  formatter = (x: any) => (x.id?(x.identificacion?x.identificacion:"")+" "+(x.razon_social?x.razon_social:""):"");

  cambiarClienteRegistrado(){
    this.cliente_registrado=!this.cliente_registrado;
  }

  establecerCliente(event){
    let cliente=(event.id || event.nit)?event:event.item;
    this.razon_busqueda=cliente.razon_social;
    this.equipo.cliente=cliente;
  }

  reiniciarCliente(){
    this.equipo.cliente={};
    this.razon_busqueda=null;
  }

  abrirPopupRegistroRapidoCliente(){
    this.modalCliente = this.modalService.open(RegistroClienteComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    this.modalCliente.componentInstance.cliente = JSON.parse(JSON.stringify(this.equipo.cliente));
    this.modalCliente.componentInstance.sucursales = [];
    this.modalCliente.componentInstance.sucursal = null;
		this.modalCliente.componentInstance.usuario = this.usuario;
		
		this.modalCliente.componentInstance.alTerminar.subscribe((res) => {
			if(res){
				if(res.tiene_error){
					this.toastr.error(res.mensaje);
					this.toastr.error(res.stack.substring(0,500));
				}else{
					this.establecerCliente(res.cliente);
					this.modalCliente.close();
				}
			}else{
				this.modalCliente.close();
			}
			
		});
  }

  buscarJugador = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
	  switchMap( (term) =>  this.campeonatosService.buscarJugador(this.campeonato.id,term)),
	  catchError(() => {
		this.searchFailed = true;
		return of([]);
	  })  ,
      tap(() => this.searching = false)
	)

  async generarMensajePendientesEconomicosEquipo(equipo){
    let detalles_ventas_pendientes:any=await this.rolesPartidosService.obtenerDetallesVentaPendientes(equipo.cliente.id).toPromise();
    if(detalles_ventas_pendientes.length==0){
      return null;
    }
    let mensaje="🙋🏻‍♂️ Apreciado Delegado de *"+equipo.nombre+"*! 😔\n\n💴 Le informamos sobre el estado de pagos pendientes al Campeonato "+this.campeonato.nombre+":\n\n";
    let total=0;
    for(let i=0;i<detalles_ventas_pendientes.length;i++){
      let fecha_venta=new Date(detalles_ventas_pendientes[i].venta.fecha);
      let texto=detalles_ventas_pendientes[i].producto.nombre+(detalles_ventas_pendientes[i].descripcion?" "+detalles_ventas_pendientes[i].descripcion:"")+" "+(fecha_venta.getDate()+"/"+(fecha_venta.getMonth()+1)+"/"+fecha_venta.getFullYear());
      let descripcion="❓ "+"Bs "+detalles_ventas_pendientes[i].venta.saldo.toFixed(2)+" "+texto;
      mensaje=mensaje+descripcion+"\n";
      total=total+detalles_ventas_pendientes[i].venta.saldo;
    }
    return mensaje+"\n 💵 Total Bs "+total.toFixed(2);
  }

  async copiarPendientesEconomicosEquipo(equipo){
    this.blockUI.start();
    try{
      let mensaje=await this.generarMensajePendientesEconomicosEquipo(equipo);
      if(mensaje){
        await navigator.clipboard.writeText(mensaje);
        this.toastr.success("Mensaje copiado! Péguelo en el chat de whatsapp.");
      }else{
        this.toastr.info("El equipo no tiene deudas pendientes!");
      }
    }catch(e){
      this.toastr.error("No se pudo copiar el mensaje!");
    }
    this.blockUI.stop();
  }

  async enviarPendientesEconomicosEquipo(equipo){
    this.blockUI.start();
    let mensaje=await this.generarMensajePendientesEconomicosEquipo(equipo);
    if(mensaje){
      let envio:any={
        telefono_whatsapp:equipo.cliente.telefono1,
        mensaje:mensaje,
        empresa:{id:this.usuario.id_empresa}
      };
      this.socket.emit('enviarKardexEconomicoEstudianteWhatsapp',envio);
      this.toastr.success("Se envio el mensaje por whatsapp satisfactoriamente!");
    }else{
      this.toastr.info("El equipo no tiene deudas pendientes!");
    }
    this.blockUI.stop();
  }

  copiarEnlace(equipo){
    navigator.clipboard.writeText(GlobalVariable.SERVER_URL+"tor/club/"+CryptoJS.AES.encrypt(equipo.cliente.id.toString(),GlobalVariable.Dictionary.TIPO_RECURSOS_MULTIMEDIA).toString().replaceAll('/','Por21Ld'));
  }

  actualizarAtributoEquipo(equipo,atributo,valor){
		this.blockUI.start();
		let datos:any={
			atributo:atributo,
			valor:valor
		};
		if(equipo){
			datos.equipo=equipo;
		}else{
			datos.id_campeonato=this.campeonato.id;
		}
		this.campeonatosService.actualizarAtributoEquipo(datos).subscribe((res:any) => {
			this.obtenerEquiposCampeonato();
			this.toastr.success(res.mensaje);
			this.blockUI.stop();
		});
	}

  buscarProducto = (text$: Observable<string>) =>
      text$.pipe(
        debounceTime(300),
        distinctUntilChanged(),
        tap(() => this.searching = true),
      switchMap( (termp) =>  this.productosService.buscarProducto(this.usuario.id_empresa,termp)),
      catchError(() => {
      this.searchFailed = true;
      return of([]);
      })  ,
        tap(() => this.searching = false)
    )
    
    formatterProducto = (x: any) => (x.nombre);
  
    establecerProducto($event){
      this.campeonato.derecho_cancha=$event.item
    }

    iniciarDerechoCancha(){
      this.producto_busqueda="";
    this.producto_inscripcion_busqueda="";
      this.campeonato.derecho_cancha=null;
    }

    //arbitraje por disciplina: primero se elige la disciplina y despues se busca su producto
    agregarArbitraje($event){
      $event.preventDefault();
      if(!this.arbitraje_nuevo.disciplina){
        this.toastr.error("Primero seleccione la disciplina del arbitraje.");
        return;
      }
      this.campeonato.arbitrajes=this.campeonato.arbitrajes?this.campeonato.arbitrajes:[];
      this.campeonato.arbitrajes.push({
        id_disciplina:this.arbitraje_nuevo.disciplina.id,
        disciplina:{id:this.arbitraje_nuevo.disciplina.id,nombre:this.arbitraje_nuevo.disciplina.nombre},
        id_producto:$event.item.id,
        producto:$event.item
      });
      this.arbitraje_nuevo={disciplina:null};
      this.arbitraje_busqueda="";
    }

    quitarArbitraje(indice){
      this.campeonato.arbitrajes.splice(indice,1);
    }

    /* Reglas de juego por disciplina y categoria: los minutos de cada tiempo (futbol de salon) o cuarto (baloncesto), y
       los puntos de los sets de voleibol, que se juega siempre al mejor de 3. Una regla sin categoria vale para todas las
       categorias de la disciplina; una con categoria gana sobre esa. Las usa la planilla de la app. */
    iniciarReglaNueva(){
      this.regla_nueva={disciplina:null,categoria:null,minutos_periodo:null,puntos_set:25,puntos_set_decisivo:15};
    }

    //que planilla usa la disciplina: el nombre dice baloncesto o voleibol; si no, futbol de salon (como en la app)
    tipoReglaDe(disciplina){
      let nombre=((disciplina && disciplina.nombre) || '').toUpperCase().normalize('NFD').replace(/[̀-ͯ]/g,'');
      if(nombre.indexOf('BALONCESTO')>=0 || nombre.indexOf('BASQUET')>=0){
        return 'BALONCESTO';
      }
      if(nombre.indexOf('VOLEI')>=0 || nombre.indexOf('VOLEY')>=0){
        return 'VOLEIBOL';
      }
      return 'FUTSAL';
    }

    nombreClase(tipo,id){
      let clase=(tipo && tipo.clases?tipo.clases:[]).find(c => c.id==id);
      return clase?clase.nombre:'';
    }

    //la regla en palabras para la lista: "2 tiempos de 20'", "4 cuartos de 10'", "al mejor de 3 · sets a 25, el 3º a 15"
    textoRegla(regla){
      let tipo=this.tipoReglaDe({nombre:this.nombreClase(this.tipo_disciplina,regla.id_disciplina)});
      if(tipo=='VOLEIBOL'){
        return "al mejor de 3 · sets a "+(regla.puntos_set || 25)+", el 3º a "+(regla.puntos_set_decisivo || 15);
      }
      return (tipo=='BALONCESTO'?"4 cuartos":"2 tiempos")+" de "+regla.minutos_periodo+"'";
    }

    agregarRegla(){
      let regla=this.regla_nueva;
      if(!regla.disciplina){
        this.toastr.error("Seleccione la disciplina de la regla.");
        return;
      }
      let tipo=this.tipoReglaDe(regla.disciplina);
      let entero=(valor) => { let n=parseInt(valor); return n>0?n:null; };
      if(tipo!='VOLEIBOL' && !entero(regla.minutos_periodo)){
        this.toastr.error("Indique los minutos de cada "+(tipo=='BALONCESTO'?"cuarto.":"tiempo."));
        return;
      }
      if(tipo=='VOLEIBOL' && (!entero(regla.puntos_set) || !entero(regla.puntos_set_decisivo))){
        this.toastr.error("Indique los puntos de cada set y los del set decisivo.");
        return;
      }
      let id_categoria=regla.categoria?regla.categoria.id:null;
      this.campeonato.reglas=this.campeonato.reglas?this.campeonato.reglas:[];
      if(this.campeonato.reglas.some(r => r.id_disciplina==regla.disciplina.id && (r.id_categoria || null)==id_categoria)){
        this.toastr.error("Ya hay una regla para esa disciplina y categoría: quítela primero para cambiarla.");
        return;
      }
      this.campeonato.reglas.push({
        id_disciplina:regla.disciplina.id,
        id_categoria:id_categoria,
        minutos_periodo:tipo=='VOLEIBOL'?null:entero(regla.minutos_periodo),
        puntos_set:tipo=='VOLEIBOL'?entero(regla.puntos_set):null,
        puntos_set_decisivo:tipo=='VOLEIBOL'?entero(regla.puntos_set_decisivo):null
      });
      this.iniciarReglaNueva();
    }

    quitarRegla(indice){
      this.campeonato.reglas.splice(indice,1);
    }

    //en la lista solo aparecen las disciplinas que todavia no tienen arbitraje propio
    disciplinasSinArbitraje(){
      let clases=this.tipo_disciplina && this.tipo_disciplina.clases?this.tipo_disciplina.clases:[];
      let usadas=(this.campeonato && this.campeonato.arbitrajes?this.campeonato.arbitrajes:[]).map(a => a.id_disciplina);
      return clases.filter(c => usadas.indexOf(c.id)<0);
    }

    /* Abre la pantalla de venta con la inscripcion ya cargada. Se reutiliza el mismo componente de
       venta que usa el cobro del derecho de cancha en el rol de partidos: asi la nota de venta sale
       por el camino de siempre, con sus correlativos, su caja y sus avisos, sin duplicar nada. */
    async cobrarInscripcion(equipo){
      if(!this.campeonato.producto_inscripcion || !this.campeonato.producto_inscripcion.id){
        this.toastr.error("El campeonato no tiene producto de inscripción configurado. Cargalo al modificar el campeonato.");
        return;
      }
      if(!equipo.cliente || !equipo.cliente.id){
        this.toastr.error("El equipo no tiene cliente asignado!");
        return;
      }
      this.blockUI.start();

      //el monto sugerido es el del campeonato; en la venta se puede cambiar antes de confirmar
      let monto=Number(this.campeonato.monto_inscripcion>0?this.campeonato.monto_inscripcion:
                                                           this.campeonato.producto_inscripcion.precio_unitario);

      let configuracion_aplicacion_ventas:any=await this.usuarioService.obtenerConfiguracionPaginaPorCodigo(this.usuario.id_empresa,
                                                    GlobalVariable.Dictionary.CODIGO_APP_VENTAS,
                                                    this.usuario.empresa.usar_permisos_avanzados_usuarios?this.usuario.id:0).toPromise();
      this.modalVenta=this.modalService.open(VentaComponent,{windowClass:'venta-popup',ariaLabelledBy:'modal-basic-title',size:'lg',backdrop:'static'});
      this.modalVenta.componentInstance.venta.usuario=this.usuario;
      this.modalVenta.componentInstance.usuario=this.usuario;
      this.modalVenta.componentInstance.configuracion_pagina=configuracion_aplicacion_ventas;
      this.modalVenta.componentInstance.venta.sucursales=Util.obtenerSucursalesUsuario(this.usuario);
      this.modalVenta.componentInstance.es_administrador=Util.esUsuarioAdministrador(this.usuario);
      this.modalVenta.componentInstance.venta.cliente=equipo.cliente;
      this.modalVenta.componentInstance.venta.pagado=monto;
      this.modalVenta.componentInstance.venta.sucursal=Util.obtenerSucursalesUsuario(this.usuario)[0];
      this.modalVenta.componentInstance.nombre_corto_canal_directo=this.global_variable.Dictionary.CANAL_VENTA_DIRECTA;
      this.modalVenta.componentInstance.venta.descontar_almacen=this.usuario.empresa.usar_inventario?true:false;
      /* La venta queda enlazada al equipo dentro de la misma transaccion, igual que el derecho de
         cancha se enlaza al partido. Es lo que despues permite saber a quien ya se le cobro. */
      this.modalVenta.componentInstance.venta.id_equipo_inscripcion=equipo.id;

      let precios:any=await this.productosService.obtenerPreciosProductos(this.campeonato.producto_inscripcion.id).toPromise();
      this.campeonato.producto_inscripcion.precios=precios;
      this.modalVenta.componentInstance.venta.detallesVenta=[{
        producto:this.campeonato.producto_inscripcion,
        producto_precio:precios.filter(e => e.por_defecto)[0],
        precio_unitario:monto, importe:monto, total:monto,
        es_servicio:false, es_combo:false,
        item:GlobalVariable.Dictionary.ITEM_PRODUCTO,
        editar_precio:true, cantidad:1, descuento:0, tipo_descuento:false,
        //la categoria va como descripcion, tal como se venia cargando a mano en Ventas
        descripcion:(equipo.categoria?equipo.categoria.nombre:null)
      }];
      this.modalVenta.componentInstance.inhabilitar_busqueda_item=false;
      this.modalVenta.componentInstance.inhabilitar_sucursal=true;
      this.modalVenta.componentInstance.inhabilitar_almacen=true;
      this.modalVenta.componentInstance.inhabilitar_descontar_almacen=true;
      this.blockUI.stop();

      this.modalVenta.componentInstance.alTerminar.subscribe((res) => {
        if(res){
          if(res.tiene_error){
            this.toastr.error(res.mensaje);
          }else{
            this.toastr.success(res.mensaje);
            this.modalVenta.close();
            //se refresca para que el equipo pase a mostrar su estado de pago en vez del cobro
            this.obtenerEquiposCampeonato();
          }
        }else{
          this.modalVenta.close();
        }
      });
    }

    /* Los equipos cobrados antes de que existiera el enlace tienen su venta en el sistema pero sin
       referencia al equipo. Antes de cobrar de nuevo se le muestran al usuario las ventas de
       inscripcion del cliente para que diga si alguna ya era de este equipo. */
    async abrirInscripcionEquipo(equipo){
      this.equipo_inscripcion=equipo;
      this.blockUI.start('Buscando inscripciones del cliente... espere por favor!');
      this.ventas_inscripcion=await this.campeonatosService.obtenerVentasInscripcionCliente(
                                        equipo.cliente.id,equipo.id).toPromise() as any[];
      this.blockUI.stop();
      //si el cliente no tiene ninguna inscripcion previa, no hay nada que elegir: se cobra y listo
      if(this.ventas_inscripcion.length==0 && !this.tieneInscripcionCobrada(equipo)){
        this.cobrarInscripcion(equipo);
        return;
      }
      this.modal_inscripcion_equipo=this.modalService.open(this.modal_inscripcion_equipo_ref,
        {ariaLabelledBy:'modal-basic-title',size:'lg',backdrop:'static'});
    }

    enlazarVentaInscripcion(venta){
      this.blockUI.start();
      this.campeonatosService.establecerVentaInscripcion(this.equipo_inscripcion.id,venta?venta.id:null)
        .subscribe((res:any) => {
          this.blockUI.stop();
          if(res.tiene_error){
            this.toastr.error(res.mensaje);
          }else{
            this.toastr.success(res.mensaje);
            this.modal_inscripcion_equipo.close();
            this.obtenerEquiposCampeonato();
          }
        });
    }

    //desde el mismo cuadro se puede pasar a cobrar una inscripcion nueva
    cobrarInscripcionNueva(){
      let equipo=this.equipo_inscripcion;
      this.modal_inscripcion_equipo.close();
      this.cobrarInscripcion(equipo);
    }

    /* Un equipo esta cobrado si tiene su venta de inscripcion y esa venta sigue vigente: si la
       anularon, vuelve a ofrecerse el cobro. */
    tieneInscripcionCobrada(equipo){
      return !!(equipo.venta_inscripcion && equipo.venta_inscripcion.activa);
    }

    saldoInscripcion(equipo){
      return this.tieneInscripcionCobrada(equipo)?Number(equipo.venta_inscripcion.saldo):0;
    }

    establecerProductoInscripcion($event){
      this.campeonato.producto_inscripcion=$event.item;
      //el monto sugerido sale del precio del producto, pero se puede cambiar
      if(!this.campeonato.monto_inscripcion){
        this.campeonato.monto_inscripcion=$event.item.precio_unitario;
      }
    }

    iniciarProductoInscripcion(){
      this.producto_inscripcion_busqueda="";
      this.campeonato.producto_inscripcion=null;
    }

    verSaldosClientes(campeonato){
      this.campeonato=campeonato;
      this.blockUI.start('Recuperando... espere por favor!');
      this.campeonatosService.obtenerClientesCampeonato(campeonato.id).subscribe((clientes:any) => {
        const ids_clientes = clientes.map(cliente => cliente.cliente);
        const idString = ids_clientes.join(', ');
        let fecha_actual=new Date();
        let paginator={
          filter:{
            id_empresa:this.usuario.id_empresa,
            sucursales:this.usuario.empresa.usar_clientes_sucursal?Util.obtenerSucursalesUsuario(this.usuario):[{nombre:"TODOS",id:0}],
            sucursal: this.usuario.empresa.usar_clientes_sucursal?Util.obtenerSucursalesUsuario(this.usuario)[0]:{nombre:"TODOS",id:0},
            usuarios:[{nombre_usuario:"TODOS",id:0}],
            usuario: {nombre_usuario:"TODOS",id:0},
            cliente:null,
            contacto_cliente:null,
            cuentas_liquidadas:false,
            fecha_fin:{
              year: fecha_actual.getFullYear(), 
              month: (fecha_actual.getMonth()+1),
              day:fecha_actual.getDate()
            },
            categorias:[GlobalVariable.Dictionary.SELECCION_TODOS],
            categoria:GlobalVariable.Dictionary.SELECCION_TODOS,
            clientes:idString
          },
          itemsPerPage:0,
          currentPage:1,
          column:"saldo_cliente",
          direction:"desc",
          search:0
        }
        this.paginator_saldos_clientes=paginator;
        this.clientesService.obtenerCuentasPorCobrar(paginator).subscribe((dato:any) => {
          this.cuentas_clientes=dato.clientes;
          for(let i=0;i<this.cuentas_clientes.length;i++){
            let equipo_cliente=clientes.find(c => c.cliente==this.cuentas_clientes[i].id);
            this.cuentas_clientes[i].logo=equipo_cliente?equipo_cliente.logo:null;
          }
          this.blockUI.stop();

          this.modal_saldo_equipos=this.modalService.open(this.modal_saldo_equipos_ref, {ariaLabelledBy: 'modal-basic-title',size: 'xl', backdrop: 'static', scrollable:true});
          this.modal_saldo_equipos.result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
          }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          });

        });
      });
    }

    //vuelve a leer los saldos de los clubes sin cerrar la ventana de pendientes (un jugador pudo pagar deuda de otro club)
    async actualizarSaldosClientes(){
      if(!this.paginator_saldos_clientes || this.cuentas_clientes.length==0){
        return;
      }
      let dato:any=await this.clientesService.obtenerCuentasPorCobrar(this.paginator_saldos_clientes).toPromise();
      this.cuentas_clientes.forEach(cliente => {
        let actual=dato.clientes.find(c => c.id==cliente.id);
        cliente.saldo_cliente=actual?actual.saldo_cliente:0;
      });
    }

    //ficha de deudas del jugador para cobrarle su parte; cliente es la tarjeta de pendientes desde donde se abrio, o null
    abrirFichaDeudaJugador(id_jugador,cliente){
      let modal_ficha=this.modalService.open(FichaDeudaJugadorComponent, {ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static', scrollable:true});
      modal_ficha.componentInstance.id_jugador=id_jugador;
      modal_ficha.componentInstance.usuario=this.usuario;
      modal_ficha.componentInstance.alTerminar.subscribe(async (res) => {
        modal_ficha.close();
        if(res && res.hubo_pagos){
          if(cliente){
            await this.recargarVentasPendientesCliente(cliente);
          }
          await this.actualizarSaldosClientes();
        }
      });
    }

    copiarTelefonoCliente(cliente){
      navigator.clipboard.writeText(cliente.telefono1.toString().trim()).then(() => {
        this.toastr.success("Número copiado! Búsquelo en whatsapp.");
      }).catch(() => {
        this.toastr.error("No se pudo copiar el número!");
      });
    }

    obtenerNivelDeuda(cliente){
      let saldo_maximo=Math.max(...this.cuentas_clientes.map(c => parseFloat(c.saldo_cliente)||0));
      let porcentaje=saldo_maximo>0?(parseFloat(cliente.saldo_cliente)||0)*100/saldo_maximo:0;
      return this.niveles_deuda.find(nivel => porcentaje>=nivel.porcentaje_minimo);
    }

    async verVentasPendientesCliente(cliente){
      if(cliente.mostrar_ventas_pendientes){
        cliente.mostrar_ventas_pendientes=false;
        return;
      }
      if(!cliente.ventas_pendientes){
        await this.recargarVentasPendientesCliente(cliente);
      }
      cliente.mostrar_ventas_pendientes=true;
    }

    async recargarVentasPendientesCliente(cliente){
      this.blockUI.start();
      let detalles:any=await this.rolesPartidosService.obtenerDetallesVentaPendientes(cliente.id).toPromise();
      //una venta puede tener varios detalles, se agrupan para pagar o anular la venta una sola vez
      let ventas=[];
      for(let i=0;i<detalles.length;i++){
        let venta=ventas.find(v => v.id==detalles[i].venta.id);
        if(!venta){
          venta=Object.assign({detalles:[]},detalles[i].venta);
          ventas.push(venta);
        }
        venta.detalles.push(detalles[i]);
      }
      //si la venta es una tarjeta de un jugador (PERSONAL) o ya se dividio entre los jugadores (COLECTIVA)
      if(ventas.length>0){
        let divisiones:any=await this.campeonatosService.obtenerDivisionesVentas(ventas.map(v => v.id)).toPromise();
        ventas.forEach(venta => venta.division=(divisiones.length?divisiones:[]).find(d => d.id_venta==venta.id) || null);
      }
      cliente.ventas_pendientes=ventas;
      //la deuda por jugador cambia con cada pago, anulacion o division
      cliente.jugadores_deuda=null;
      cliente.mostrar_jugadores_deuda=false;
      this.blockUI.stop();
    }

    async verDeudasJugadoresCliente(cliente){
      if(cliente.mostrar_jugadores_deuda){
        cliente.mostrar_jugadores_deuda=false;
        return;
      }
      if(!cliente.jugadores_deuda){
        this.blockUI.start();
        let res:any=await this.campeonatosService.obtenerDeudasJugadoresCliente(cliente.id,this.campeonato.id).toPromise();
        this.blockUI.stop();
        if(res.tiene_error){
          this.toastr.error(res.mensaje);
          return;
        }
        cliente.jugadores_deuda=res;
      }
      cliente.mostrar_jugadores_deuda=true;
    }

    async abrirDivisionVentaPendiente(cliente,venta){
      this.blockUI.start();
      let res:any=await this.campeonatosService.obtenerDatosDivisionVenta(venta.id,this.campeonato.id).toPromise();
      this.blockUI.stop();
      if(res.tiene_error){
        this.toastr.error(res.mensaje);
        return;
      }
      let id_equipo=(res.division.length>0 && res.division[0].id_equipo) || res.id_equipo_sugerido || (res.equipos.length>0?res.equipos[0].id:null);
      this.division_venta={cliente:cliente,venta:res.venta,equipos:res.equipos,id_equipo:id_equipo,division_anterior:res.division,jugadores:[]};
      this.cambiarEquipoDivision();
      this.modal_division_venta=this.modalService.open(this.modal_division_venta_ref, {ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static', scrollable:true});
    }

    //jugadores del equipo elegido; si la venta ya estaba dividida se marcan los de la division con su monto
    cambiarEquipoDivision(){
      let equipo=this.division_venta.equipos.find(e => e.id==this.division_venta.id_equipo);
      let anterior=this.division_venta.division_anterior;
      let usar_anterior=anterior.length>0 && anterior[0].id_equipo==this.division_venta.id_equipo;
      this.division_venta.jugadores=(equipo?equipo.jugadores:[]).map(j => {
        let en_division=usar_anterior?anterior.find(d => d.id_jugador==j.id_jugador):null;
        return {id_jugador:j.id_jugador,nombre_completo:j.nombre_completo,seleccionado:!usar_anterior || !!en_division,monto:en_division?parseFloat(en_division.monto):0};
      });
      if(!usar_anterior){
        this.repartirDivisionPartesIguales();
      }
    }

    //el total en partes iguales en bolivianos enteros; lo que sobra (bolivianos y centavos) va a un jugador al azar
    repartirDivisionPartesIguales(){
      let seleccionados=this.division_venta.jugadores.filter(j => j.seleccionado);
      this.division_venta.jugadores.forEach(j => j.monto=0);
      if(seleccionados.length==0){
        return;
      }
      let total_centavos=Math.round(parseFloat(this.division_venta.venta.total)*100);
      let base=Math.floor(total_centavos/100/seleccionados.length)*100;
      let sobrante=total_centavos-base*seleccionados.length;
      let al_azar=Math.floor(Math.random()*seleccionados.length);
      seleccionados.forEach((j,i) => j.monto=(base+(i==al_azar?sobrante:0))/100);
    }

    seleccionarTodosDivision(seleccionado){
      this.division_venta.jugadores.forEach(j => j.seleccionado=seleccionado);
      this.repartirDivisionPartesIguales();
    }

    obtenerSumaDivision(){
      return this.division_venta.jugadores.filter(j => j.seleccionado).reduce((total,j) => total+(parseFloat(j.monto) || 0),0);
    }

    esDivisionCuadrada(){
      return Math.abs(this.obtenerSumaDivision()-parseFloat(this.division_venta.venta.total))<=0.009;
    }

    guardarDivisionVenta(){
      let jugadores=this.division_venta.jugadores.filter(j => j.seleccionado && j.monto>0).map(j => ({id_jugador:j.id_jugador,monto:j.monto}));
      if(!this.esDivisionCuadrada()){
        this.toastr.error("¡La suma de los montos debe ser igual al total de la venta!");
        return;
      }
      this.blockUI.start();
      this.campeonatosService.guardarDivisionVenta(this.division_venta.venta.id,{id_equipo:this.division_venta.id_equipo,id_campeonato:this.campeonato.id,jugadores:jugadores}).subscribe(async (res:any) => {
        this.blockUI.stop();
        if(res.tiene_error){
          this.toastr.error(res.mensaje);
          return;
        }
        this.toastr.success(res.mensaje);
        this.modal_division_venta.close();
        await this.recargarVentasPendientesCliente(this.division_venta.cliente);
      });
    }

    quitarDivisionVenta(){
      this.blockUI.start();
      this.campeonatosService.quitarDivisionVenta(this.division_venta.venta.id).subscribe(async (res:any) => {
        this.blockUI.stop();
        if(res.tiene_error){
          this.toastr.error(res.mensaje);
          return;
        }
        this.toastr.success(res.mensaje);
        this.modal_division_venta.close();
        await this.recargarVentasPendientesCliente(this.division_venta.cliente);
      });
    }

    abrirPagoVentaPendiente(cliente,venta){
      let saldo_anterior=venta.saldo;
      let modal_pago=this.modalService.open(PagoVentaComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
      modal_pago.componentInstance.venta = {id:venta.id,cliente:cliente};
      modal_pago.componentInstance.usuario = this.usuario;
      modal_pago.componentInstance.alTerminar.subscribe(async (res) => {
        if(res && res.tiene_error){
          this.toastr.error(res.mensaje);
          return;
        }
        modal_pago.close();
        if(res){
          this.toastr.success(res.mensaje);
          cliente.saldo_cliente=parseFloat(cliente.saldo_cliente)-Math.min(res.pago?res.pago.monto_pagado:0,saldo_anterior);
          await this.recargarVentasPendientesCliente(cliente);
        }
      });
    }

    abrirAnulacionVentaPendiente(cliente,venta){
      let popup=this.modalService.open(PopupConfirmacionComponent);
      popup.componentInstance.message = "¿Esta seguro(a) de anular la venta de Bs "+venta.total.toFixed(2)+"?";
      popup.componentInstance.data = {id:venta.id,transaccion_nombre_corto:venta.transaccion?venta.transaccion.nombre_corto:null};
      popup.componentInstance.es_venta = true;
      popup.componentInstance.onConfirm.subscribe(($e) => {
        popup.close();
        if($e.confirm){
          this.anularVentaPendiente(cliente,venta,$e.data);
        }
      });
    }

    anularVentaPendiente(cliente,venta,datos_anulacion){
      this.blockUI.start();
      datos_anulacion.usar_facturacion_computarizada_en_linea_por_sucursal_empresa=this.usuario.empresa.usar_facturacion_computarizada_en_linea_por_sucursal_empresa;
      this.ventasService.anularVenta(datos_anulacion).subscribe(async (res:any) => {
        this.blockUI.stop();
        if(res.tiene_error){
          this.toastr.error(res.mensaje);
        }else{
          this.toastr.success(res.mensaje);
          cliente.saldo_cliente=parseFloat(cliente.saldo_cliente)-venta.saldo;
          await this.recargarVentasPendientesCliente(cliente);
        }
      });
    }

    async abrirEstadoCuentaCliente(cliente){
      this.modalHistoricoVentas = this.modalService.open(ClientesHistoricoVentasComponent, {windowClass:'historico-ventas', scrollable:true, ariaLabelledBy: 'modal-basic-title',size: 'md', backdrop: 'static'});
      this.modalHistoricoVentas.componentInstance.cliente = cliente;
      this.modalHistoricoVentas.componentInstance.usuario = this.usuario;
      this.modalHistoricoVentas.componentInstance.mostrar_filtro_fechas = false;
      this.modalHistoricoVentas.componentInstance.mostrar_boton_busqueda = false;
      this.modalHistoricoVentas.componentInstance.cuentas_liquidadas = this.filter.cuentas_liquidadas;
      this.modalHistoricoVentas.componentInstance.titulo_reporte = "CUENTAS POR COBRAR";
      
      this.modalHistoricoVentas.componentInstance.alTerminar.subscribe((res) => {
        this.modalHistoricoVentas.close();
      });
    }
}
